import axios from 'axios';
import { apiErrors } from '@/data/content';

const api = axios.create({
    baseURL: '/',
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

export const getApiErrorMessage = (error: unknown, fallback = apiErrors?.default_fallback) => {
    if (!error) return fallback;
    const err = error as { response?: { data?: { message?: string } }; userMessage?: string; message?: string };
    if (err.response?.data?.message) return err.response.data.message;
    if (err.userMessage) return err.userMessage;
    if (typeof err.message === 'string') return err.message;
    return fallback;
};

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const fallbackMsg = error.response
            ? error.response.data?.message || apiErrors?.default_fallback
            : error.request
              ? apiErrors?.network_error
              : error.message || apiErrors?.unknown_error;

        const wrapped = Object.create(error);
        wrapped.userMessage = fallbackMsg;
        return Promise.reject(wrapped);
    }
);

export default api;
